import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { BaseService } from 'src/app/core/services/base.service';
import { LoginMetric } from 'src/app/main/metrics/models/login-metric.model';

@Injectable({
  providedIn: 'root'
})
export class MetricsService extends BaseService {
  private baseUrl = '/metric';

  getLogins(month: number, year: number): Observable<Array<LoginMetric>> {
    const params = new HttpParams()
        .append('month', String(month))
        .append('year', String(year));

    return this.baseGetWithParams<Array<LoginMetric>>(`${this.baseUrl}/login`, params);
  }

}
